import axios from '@/http'

//老师保存白板文件
export function addFileBord(data) {
    return axios({
        url: '/api/white-board-file/add-file',
        method: 'GET',
        params:data
    })
}

// //获取学生白板文件分页
// export function getStuBors(data) {
//     return axios({
//         url: '/api/white-board-file/get-student-file-pages',
//         method: 'GET',
//         params:data
//     })
// }
//获取老师白板文件分页
export function getTeacherBors(data) {
    return axios({
        url: '/api/white-board-file/get-teacher-file-pages',
        method: 'POST',
        data
    })
}
//老师分享白板文件
export function teaShareBord(data) {
    return axios({
        url: '/api/white-board-file/share-file',
        method: 'POST',
        data
    })
}
// 老师取消分享白板文件
export function delShareBord(data) {
    return axios({
        url: '/api/white-board-file/del-share-files',
        method: 'GET',
        params:data
    })
}

//老师删除白板文件
export function teaDelBord(data) {
    return axios({
        url: '/api/white-board-file/del-file',
        method: 'GET',
        params:data
    })
}
//获取班级列表
export function getClass(data) {
    return axios({
        url: '/api/white-board-file/get-classes',
        method: 'GET',
        params:data
    })
}
//板书重命名
export function renewName(data) {
    return axios({
        url: '/api/white-board-file/update-file',
        method: 'POST',
        data
    })
}
//板书重命名
export function getFileDays(data) {
    return axios({
        url: '/api/white-board-file/get-file-days',
        method: 'GET',
        params:data
    })
}

// //老师删除白板文件
// export function teaDelBord(data) {
//     return axios({
//         url: '/api/white-board-file/del-file',
//         method: 'GET',
//         params:data
//     })
// }
